import { createReducer, on } from "@ngrx/store";
import { loadFormulaGroupByIdAct, resetFormulaGroupAct, saveSuccessFormulaGroupAct, setViolationsFormulaGroupAct, showMsgErrorAct, updateSuccessFormulaGroupAct } from "./formula-group.action";
import { FormulaGroup } from "../../models/formulas/formula-group";

const formulaGroup: FormulaGroup = new FormulaGroup();

export const formulaGroupReducer = createReducer (
    {
        formulaGroup,
        violations: {},
        loading: true
    },
    on(resetFormulaGroupAct, (state) => ({
        formulaGroup:  { ...formulaGroup },
        violations: {},
        loading: state.loading
    })),
    on(loadFormulaGroupByIdAct, (state, { formulaGroup }) =>({
        formulaGroup: { ...formulaGroup}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessFormulaGroupAct, (state, { formulaGroupNew }) => ({
        formulaGroup: { ...formulaGroupNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessFormulaGroupAct, (state, { formulaGroupUpdated }) => ({
        formulaGroup: { ...formulaGroupUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsFormulaGroupAct, (state, { formulaGroupForm, violations }) => ({
        formulaGroup: { ...formulaGroupForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        formulaGroup: state.formulaGroup ,
        violations: {},
        loading: false
    }))
)